import { QueryClientProvider } from '@tanstack/react-query'
import { createRootRoute, Outlet } from '@tanstack/react-router'
import { InstallPrompt } from '@/components/app/install-prompt'
import { OfflineBanner } from '@/components/app/offline-banner'
import { UpdatePrompt } from '@/components/app/update-prompt'
import { Toaster } from '@/components/ui/sonner'
import { queryClient } from '@/lib/query'

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
})

function RootLayout() {
  return (
    <QueryClientProvider client={queryClient}>
      <OfflineBanner />
      <Outlet />
      <InstallPrompt />
      <UpdatePrompt />
      <Toaster position="top-center" />
    </QueryClientProvider>
  )
}

function NotFound() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-navy-950 px-6 text-center">
      <p className="text-[26px] font-bold text-chalk">Page introuvable</p>
      <p className="text-[14px] text-steel">Cette page n'existe pas ou a été déplacée.</p>
      <a
        href="/"
        className="mt-4 rounded-[14px] bg-gold px-6 py-3 text-[15px] font-semibold text-navy-950"
      >
        Retour à l'accueil
      </a>
    </div>
  )
}
